export default __webpack_public_path__ + "static/62-2b089b30fb0561d32af16d948bf0deab.gif";